/*
 * Permissões do sistema. Quem pode o quê fica na API (config/permissions.php):
 * ela manda, junto com o usuário (GET users/{id}), a lista de permissões do
 * perfil (`role.abilities`, '*' = todas) e a tela inicial (`role.home`). Aqui
 * só ficam os nomes, para as telas perguntarem can(ABILITIES.X) sem saber qual
 * é o perfil. Permissão nova: criar na API e acrescentar o nome aqui.
 *
 * Transição: as rotas e o menu ainda usam as listas de papéis (roles={[1, 2]},
 * isAdmin()...) no que não foi migrado. Ao migrar uma tela, troque a lista
 * pela permissão.
 */
export const ABILITIES = {
  DASHBOARD: 'dashboard',
  PREMIERE_PRESS_LIST: 'premiere.press-list',
  INTERNATIONAL_PRESS_LIST: 'international.press-list',
  // Credenciamento > Imprensa: listagem, ficha e cadastro de Imprensa,
  // convites, pedidos de ingressos e aprovação do credenciamento
  PRESS_CREDENTIALS: 'press.credentials',
  // Credenciais de todos os tipos (sem ela, ficha e cadastro só de Imprensa)
  CREDENTIALS_MANAGE: 'credentials.manage',
  CREDENTIALS_DELETE: 'credentials.delete',
  // Apagar o pedido de ingressos de um profissional de imprensa para ele
  // enviar de novo (Administrador e Assessoria de Imprensa)
  PRESS_TICKETS_RESET: 'press.tickets.reset',
};

export const userCan = (user, ability) => {
  const abilities = user?.role?.abilities || [];
  return abilities.includes('*') || abilities.includes(ability);
};

// Tela inicial do perfil: depois do login e ao tentar abrir tela proibida
export const homePathOf = user => user?.role?.home || '/dashboard';
